export default __webpack_public_path__ + "static/media/num-2.aee07b4f.svg";